// export type EmailNotificationFilterType = 'STANDARD_LIST' | 'CUSTOM_LIST' | 'KEYWORDS';

export enum EmailNotificationFilterType {
    'STANDARD_LIST' = 'STANDARD_LIST',
    'CUSTOM_LIST' = 'CUSTOM_LIST',
    'KEYWORDS' = 'KEYWORDS',
}
